// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__UDO4R","title":"Advt_title__ImZhc","wiggle":"Advt_wiggle__ecfIf","qrsWrapper":"Advt_qrsWrapper__HcQAK","qrCode":"Advt_qrCode__H7wkA"};